/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-return */

import { Component, Input, OnInit } from '@angular/core'
import { AbstractControl, ValidationErrors } from '@angular/forms'
import { ValidationMessageService } from '../services/validation-message.service'
import { CacheService } from '../../services/business/cache.service'
import { PreviewStateService } from '../../services/ui/preview-state.service'

@Component({
    selector: 'validation-messages',
    templateUrl: './validation-messages.component.html',
    styleUrls: ['./validation-messages.component.scss'],
})
export class ValidationMessagesComponent implements OnInit {

    @Input() control: AbstractControl

    constructor(
        public readonly validationMessageService: ValidationMessageService,
        private readonly cacheService: CacheService,
        private readonly previewState: PreviewStateService,
    ) {
    }

    /**
     * Offered from here rather than from each screen, so every screen using these messages can
     * have its field validation branded without knowing anything about the editor.
     */
    ngOnInit(): void {
        if (this.cacheService.getPreviewMode())
            this.previewState.offer([{ key: 'fieldErrors' }])
    }

    get validationMessage(): string {
        // While branding, the message is shown without the field having to fail, which preview
        // mode cannot always be made to do.
        if (this.previewState.is('fieldErrors'))
            return this.validationMessageService.getValidatorErrorMessage('required', true, null)

        if (this.control?.status === 'INVALID' && this.control?.touched) {
            for (const propertyName in this.control.errors) {
                const params = this.getParams(this.control.errors)
                return this.validationMessageService.getValidatorErrorMessage(propertyName, this.control.errors[propertyName], params)
            }
        }
        return null
    }

    getParams(errors: ValidationErrors): any {
        let params = null
        if (errors.maxlength) {
            params = { 'length': errors.maxlength.requiredLength }
        } else if (errors.minlength) {
            params = { 'length': errors.minlength.requiredLength }
        }
        return params
    }

}
